import { Button } from '@depop/web-thrift-ui/Button';
import { ClothesPile } from '@depop/web-thrift-ui/Illustrations/ClothesPile';
import { Body } from '@depop/web-thrift-ui/Typography';
import { useTranslations } from 'next-intl';

import styles from './styles.module.css';

import { ExtendedLink } from '@/components/ExtendedLink';

export function GuestCheckoutSummaryEmpty() {
  const t = useTranslations('checkout');

  return (
    <div className={styles.emptyState}>
      <ClothesPile size="regular" />
      <Body variant="md-bold">{t('GuestSummary.Empty.Title')}</Body>
      <Body variant="sm-regular">{t('GuestSummary.Empty.Description')}</Body>
      <ExtendedLink href="/explore">
        <Button as="span">{t('GuestSummary.Empty.Cta')}</Button>
      </ExtendedLink>
    </div>
  );
}
